module.exports = __webpack_public_path__ + "f8aeea01f9de11cd6e9419a6c4b0b413.png";